const urlHome = import.meta.env.VITE_URL_HOME;
const urlApi = import.meta.env.VITE_URL_API;
const urlSocket = import.meta.env.VITE_URL_SOCKET;

export { urlHome, urlApi, urlSocket };
